<!-- 我的动态 -->
<template>
  <div class="bar_blog">
    <el-row :gutter="0" class="dashed">
      <el-col :span="12">
        <div class="grid-content bg-purple title1">我的技能服务</div>
      </el-col>
      <el-col class="clear" :span="12" v-if="UserProof.checkStatus == 2">
        <span class="rt creatPhotoBtn" @click="jump()">+发布服务技能</span>
      </el-col>
    </el-row>
    <el-row class="repeatable pd_lr_60" v-if="myServiceList.length == 0">
      <div>
        <empty :acceptEmptyData="acceptEmptyData"></empty>
      </div>
      <p style="text-align: center;margin: 20px 0" v-if="UserProof.checkStatus == 1 || UserProof.checkStatus == 2">
        <span class=" creatPhotoBtn" @click="jump()">+发布服务技能</span>
      </p>
      <p style="text-align: center;margin: 20px 0" v-if="UserProof.checkStatus == 0 || UserProof.checkStatus == 3">
        <span class=" creatPhotoBtn" @click="$router.push('/home/authenticate')">您还未通过认证，前往认证服务者</span>
      </p>
    </el-row>
    <el-row class="repeatable pd_lr_60" v-if="myServiceList.length > 0">
      <el-col :span="12" class="service-area" v-for="itemServ in myServiceList" :key="itemServ" @click="ServicesBtn(itemServ)">
        <div class="service-img-area pos_rel"  @click="ServicesBtn(itemServ)">
          <img :src="itemServ.serveCoverImg" alt="">
          <div class="service-icon-area">
            <!--status     0审核成功 1未审核 2审核失败-->
            <span v-if="itemServ.status == 0"  style="background: #1CAFAF">等待审核中</span>
            <span v-if="itemServ.status == 1"  style="background: #f60">已发布</span>
            <span v-if="itemServ.status == 2"  style="background: red ">审核未通过</span>
            <span v-if="itemServ.status == 3"  style="background:#9B9B9B">已下架</span>
          </div>
          <div class="pos_abs" v-if="itemServ.status == 0 || itemServ.status == 1">
            <span @click.stop="del(itemServ.code)">✘下架该服务</span>
          </div>
          <!--<div class="pos_abs service-icon-area">-->
            <!--<span class="iconfont icon-fabu"></span>-->
            <!--<span class="iconfont icon-shanchu2"></span>-->
          <!--</div>-->
        </div>
        <div class="service-intro"  @click="ServicesBtn(itemServ)">
            <div class="service-content">{{itemServ.title}}</div>
          <div class="clear">
            <span class="lf fontGreen">{{itemServ.pushTypeStr}}</span>
            <span class="rt fontState">&yen;{{itemServ.pushPrice}}元/{{itemServ.servePriceName}}</span>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<!--JS-->
<script>
  import { selectUserServes,deleteUserServesByCode,selectUserProof } from "api/apis";
  import empty from '../../components/common/empty'
  import $ from "jquery";

  export default {
    components: {
      empty
    },
    data() {
      return { 
        acceptEmptyData: {
          from: 'services',
          msg: '您暂时还没有发布服务信息哦，可先去发布服务～'
        },  
        code: localStorage.getItem('pbw_user_pc_uid'),
        myServiceList:[],
        UserProof:''
      }
    },
    methods: {
      del(code){
        let vm = this
        vm.$confirm('下架该技能服务？, 下架后用户将无法下单', '下架服务', {
          confirmButtonText: '确定下架',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        }).then(() => {
          deleteUserServesByCode({code:code}).then((res) => {
            if (res.code == '000000') {
              vm.$message.success('下架成功')
              vm.getServices()
            } else {
              vm.$message.warning(res.msg ? res.msg : '暂未请求到数据，请稍后重试！')
            }
          })
        }).catch(() => {

        });

      },
      ServicesBtn(item){
        this.$router.push('/homePage?nameCode=' + item.userCode + '&nameService=' + item.code)
      },
      getServices () {
        let vm = this
        let params = {}
        params = {
          userCode: vm.code,
          role: 1,
        }
        // 获取服务列表
        selectUserServes(params).then((res) => {
          if (res.code == '000000') {
         
            vm.myServiceList = res.data
          } else {
            vm.$message.warning(res.msg ? res.msg : '暂未请求到数据，请稍后重试！')
          }
        })
        // 认证信息
        selectUserProof({uid: localStorage.getItem('pbw_user_pc_uid')}).then((res) => {
          if (res.code == '000000') {
            vm.UserProof = res.data
          } else {
            vm.$message.warning(res.msg ? res.msg : '数据加载中，请稍后')
          }
        })
      },
      jump () {
        this.$router.push({
          name: 'service'
        })
      }
    },
    created () {
      this.getServices()
    }
  }
</script>
<style lang="scss" scoped>
    @import '../../../src/scss/commonH5.scss';
    @import '../../scss/demo.scss';
    /* 基本资料 */
    .avatar{
      height: 120px;
      border-radius: 90px;
      border: 1px solid #d6d6d6;
    }
    .bar_blog .dashed {
      border-bottom: 1px dashed #F1F1F1;
      padding-bottom: 20px;
      margin-bottom: 25px;
    }
    .bar_blog .title1 {
      font-size: 18px;
      color: #333;
    }
    .bar_blog .title1::before {
      content: '';
      display: inline-block;
      width: 5px;
      height: 27px;
      border-radius: 5px;
      vertical-align: bottom;
      background-color: #F16202;
      margin-right: 20px;
    }
    .bar_blog .title2, .bar_blog .title2 em {
      text-align: right;
      font-size: 14px;
      color: #959595;
      line-height: 27px;
    }
    .bar_blog .repeatable {
      padding-bottom: 20px;
    }
    .bar_blog .repeatable .name {
      font-size: 14px;
      text-align: right;
      line-height: 40px;
    }
    .bar_blog .repeatable .in input {
      color: #F16202
    }
    .el-border{
      border-radius: 50%;
      width: 100px;
      height: 100px;
      line-height: 100px;
      border: 1px solid #ddd;
      text-align: center;
    }
    .bar_blog .repeatable .sex {
      line-height: 40px;
      padding-left: 10px;
    }

    .name_money{
      padding: 20px 80px;
      border: 1px solid #d5d5d5;
      span{
        color: #f60;
      }
    }

    .personal-money-tip{
      font-size: 24px;
    }
    .personal-money{
      font-size: 56px;
      font-weight: bold;
    }
    .personal-money-btn{
      color: #fff !important;
      background: #698adb;
      padding: 16px 50px;
      border-radius: 10px;
      font-size: 18px;
    }
    .personal-money-btm-tip{
      color: #999 !important;
      float: right;
      margin-top: -20px;
      margin-right: 30px;
    }
    .personal-money-one{
      color: #fff !important;
      background: #698adb;
      padding: 6px 30px;
      border-radius: 10px;
      font-size: 16px;
      margin-top: 24px;
    }
    .personal-money-two{
      color: #fff !important;
      background: #26b3f4;
      padding: 6px 30px;
      border-radius: 10px;
      font-size: 16px;
      margin-top: 24px;
      margin-right: 20px;
    }

    /*陪陪服务*/
    .service-area{
      cursor: pointer;
      width: 48%;
      border-radius: 5px;
      box-shadow: 2px 4px 8px 4px rgba(197, 197, 197, 0.3);
      margin: 0px 20px 20px 0px;
      img{
        transition:all 0.3s;-webkit-transition:all 0.3s;-moz-transition:all 0.3s;
      }
      :hover img{
        opacity:0.8;filter:alpha(opacity=80);
        transform:scale(1.03);-webkit-transform:scale(1.03);-moz-transform:scale(1.03);
      }
      img{
        width: 100%;
        height: 156px;
        border-radius: 5px;
      }
      .service-icon-area{
        position: absolute;
        top: 14px;
        left: 10px;
      }
      .pos_abs{
        position: absolute;
        bottom: 14px;
        right: 10px;
        span{
          color: #fff;
          padding: 5px;
          background: red;
        }
      }
      .service-img-area{
        position: relative;
        span{
          letter-spacing: 2px;
          font-size: 12px;
          padding: 3px 6px;
          border-radius: 50px;
          margin: 0 5px;
          color: #fff;
        }

        .icon-fabu{
          background: #f4b726;
        }
        .icon-shanchu2{
          background: #26f4b3;
        }
      }
      .service-intro{
        font-size: 16px;
        color: #666;
        padding: 10px 10px 12px;
      }
      .service-content{
        -o-text-overflow: ellipsis;
        text-overflow:ellipsis;
        overflow:hidden;
        white-space:nowrap; 
        width: 100%;
        padding: 5px 0;
      }
      .fontState{
        font-size: 18px;
        color: #f42626;
        margin-top: -6px;
      }
      .fontGreen{
        font-size: 12px;
        color: #EB5248;
        border: 1px solid #EB5248;
        padding: 0px 4px;
        border-radius: 25px;
        letter-spacing: 2px;
      }
    }
    .service-area:nth-child(2n+0){
      margin-right: 0px;
    }
    .pd_lr_60{
      padding: 0px 30px;
    }
    .creatPhotoBtn {
      color: #f60;
      border: 1px solid #f60;
      font-size: 16px;
      padding: 2px 16px;
      border-radius: 50px;
      cursor: pointer;
      &:hover{
        background: #f60;
        color: #fff;
      }
    }
</style>



// WEBPACK FOOTER //
// src/views/home/services.vue